<template>
  <form
    id="login"
    method="post"
    action="/nl/webshop/payment/login"
    @submit.prevent="login"
  >

    <fieldset class="warning">
      <legend>&nbsp;</legend>
      <div class="form-row inline-label">
        <div class="form-column">
          <label for="username" class="required">{{ $t('loginForm.username') }}</label>

          <input id="username" v-model="username" type="text" name="username"
                 autocomplete="off">
          <ul v-if="errorCode.username" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
            <li>{{ $t(`loginForm.errors.${errorCode.username}`) }}</li>
          </ul>
        </div>
      </div>
      <div class="form-row inline-label">
        <div class="form-column">
          <label for="password" class="required">{{ $t('loginForm.password') }}</label>
          <input id="password" v-model="password" type="password" name="password"
                 autocomplete="off">
          <ul v-if="errorCode.password" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
            <li>{{ $t(`loginForm.errors.${errorCode.password}`) }}</li>
          </ul>
        </div>
      </div>
    </fieldset>
    <fieldset class="submit">
      <div class="form-row">
        <div class="form-column">
          <input id="submit-login" :value="$t('loginForm.login')" type="submit" name="submit-login">
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>

import {CLEAR_ORDER_VALIDATION_ERRORS} from '../store/modules/cart/mutation-types'

export default {
  name: 'LoginForm',
  data: function () {
    return {
      'username': '',
      'password': '',
      errorCode: {
        username: null,
        password: null
      }
    }
  },
  methods: {
    validateForm () {
      this.errorCode.username = this.username !== '' ? null : 'username-required'
      this.errorCode.password = this.password !== '' ? null : 'password-required'
      return !this.errorCode.username && !this.errorCode.password
    },

    async login () {
      if (this.validateForm()) {
        try {
          await this.$store.dispatch('user/websiteUserLogin', { username: this.username, password: this.password })
          this.password = ''
          await this.$store.dispatch('user/fetchUser')
          this.$store.commit('cart/' + CLEAR_ORDER_VALIDATION_ERRORS)
        } catch (e) {
          if (e.hasOwnProperty('code')) {
            this.errorCode.username = e.code
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/LoginForm.vue